import 'core-js/stable/global-this';
import React, { useEffect, useState } from "react";
// Resize
import useWindowSize from "Hooks/useWindowSize";

//Libraries
import Slider from "react-slick";

// Sass
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ce20.css";
// import 'Sass/includes/Components/modules/CE20.sass'

// import CE41CompaniesOrg from "../CE41";
// import { set } from 'react-hook-form';
import Parser from "html-react-parser";

import {
  BankService,
  ConfigService,
  DeparmentsService,
  DocumentTypeService,
  EntitiesService,
  ModalitiesService,
  OperatorsService,
  PlanService,
} from "actions/HttpCalls";
import { HttpClient } from "actions/HttpClient";
import CE20CompaniesOrg from '../CE20';
import ActivarComponent from './activarComponent';

const httpClient = new HttpClient();
const configService = new ConfigService(httpClient);
const deparmentsService = new DeparmentsService(httpClient);
const entitiesService = new EntitiesService(httpClient);
const modalitiesService = new ModalitiesService(httpClient);
const operatorsService = new OperatorsService(httpClient);
const documentTypeService = new DocumentTypeService(httpClient);
const planService = new PlanService(httpClient);
const bankService = new BankService(httpClient);

function DaviviendaComponent({idBanco}) {


    useEffect(() => {
      try{
        if(document.getElementById("texto-movilD") && document.getElementById("texto-hogarD")) {
          document.getElementById("texto-movilD").style.display = "none";
          document.getElementById("texto-hogarD").style.display = "block";
          console.log("ocultar")
        }
      }catch(e){}
    }, [])

  const [showCE41Form, setShowCE41Form] = useState("davivienda");

  const [showBanco, setShowBanco] = useState(true);

  const [dataDepartments, setDataDepartments] = useState([]);
  const [dataEntities, setDataEntities] = useState([]);
  const [dataModalities, setDataModalities] = useState([]);
  const [dataOperators, setDataOperators] = useState([]);
  const [dataDocumentTypes, setDataDocumentTypes] = useState([]);
  const [dataPlanes, setDataPlanes] = useState([]);
  // const [dataPlanByID, setDataPlanByID] = useState([])
  const [dataOfBanks, setDataOfBanks] = useState([]);
  const [dataConfig, setDataConfig] = useState([]);
  const [txtTerms5, setTxtTerms5] = useState('');

  const getValuesDefault = async () => {
    const banks = await bankService.getBanksItems(idBanco);
    setDataOfBanks(banks);

    const config = await configService.getConfigItems(idBanco);
    setDataConfig(config);

    console.log("banks: ", banks);
    console.log("config: ", config);
   
    if(config?.text_TERMS_5 && String(config?.text_TERMS_5).indexOf("http") >= 0){
      const Terms5 = await configService.getTerms5Html(config?.text_TERMS_5_HOGAR);
      console.log("Terms5: ", Terms5);
      setTxtTerms5(Terms5);
    }
    
    if(banks.length > 0){
      if (banks?.length && config?.title_REGISTRE) {
        const deparments = await deparmentsService.getDepartmentsItems();
        let deparmentsFilt = deparments
          ? deparments.filter((dp) => dp.fi_banco === idBanco)
          : [];
          
        setDataDepartments(deparmentsFilt);
  
        const entities = await entitiesService.getEntitiesItems();
        let entitiesFilt = entities
          ? entities.filter((ent) => ent.fi_banco === idBanco)
          : [];
        setDataEntities(entitiesFilt);
  
        const modalities = await modalitiesService.getModalitiesItems();
        let modalitiesFilt = modalities
          ? modalities.filter((mo) => mo.fi_banco === idBanco)
          : [];
        setDataModalities(modalitiesFilt);
  
        const operators = await operatorsService.getOperatorItems();
        let operatorsFilt = operators
          ? operators.filter((op) => op.fi_banco === idBanco)
          : [];
        setDataOperators(operatorsFilt);
  
        const documentType = await documentTypeService.getDocumentTypeItems();
        let documentTypeFilt = documentType
          ? documentType.filter((dt) => dt.fi_banco === idBanco)
          : [];
          console.log(documentTypeFilt, "banks3")
        setDataDocumentTypes(documentTypeFilt);
  
        const planes = await planService.getPlanesItems();
        let planesFilter = planes
          ? planes.filter((pl) => pl.fi_banco === idBanco)
          : [];
        setDataPlanes(planesFilter);
  
        console.log("planes....> ", planesFilter);
        console.log("documentType....> ", documentTypeFilt);
        console.log("deparments....> ", deparmentsFilt);
        console.log("entities....> ", entitiesFilt);
        console.log("operators....>", operatorsFilt);
        console.log("modalities: ", modalitiesFilt);
      }

    } else {
        setShowBanco(false);
    }
    
    
    
  };

  useEffect(() => {
    getValuesDefault();
    // eslint-disable-next-line
  }, []);

  const ajustarCard = function (className) {
    var altura, i, maxHeight, total;
    var els = document.getElementsByClassName(className);

    // Limpia todos los height
    Array.prototype.forEach.call(els, function (el) {
      el.style.height = "";
    });

    // Se optienen todos los height
    altura = [];
    total = els.length - 1;
    i = 0;
    while (i <= total) {
      altura.push(els[i].offsetHeight);
      i++;
    }
    // Se optiene la height maxima entre todas las tarjetas
    maxHeight = Math.max.apply(null, altura);

    // Se aplica a todos la height
    Array.prototype.forEach.call(els, function (el) {
      // console.log(el.offsetHeight);
      el.style.height = maxHeight + "px";
    });
  };

  const {
    // height: heightWindow,
    width: widthWindow,
  } = useWindowSize();

  // ajusta siempre que cambia
  useEffect(() => {
    ajustarCard("ce20ItemHeader");
    ajustarCard("ce20ItemDesc");
  }, []);

  useEffect(() => {
    ajustarCard("ce20ItemHeader");
    ajustarCard("ce20ItemDesc");
  }, [widthWindow]);

  const settingsSlider = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: false,
    centerMode: true,
    centerPadding: "28px",
    responsive: [
      {
        breakpoint: 640,
      },
      {
        breakpoint: 100000,
        settings: "unslick",
      },
    ],
  };

  function showMovilText() {
    // document.getElementById("texto-movilD").style.display = "block";
    //     document.getElementById("texto-hogarD").style.display = "none";
    if(document.getElementById("texto-movilD") && document.getElementById("texto-hogarD")) {
          document.getElementById("texto-movilD").style.display = "block";
          document.getElementById("texto-hogarD").style.display = "none";
          console.log("ocultar")
        }
  }

  function openInNewTab(url) {
    const newWin = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWin) newWin.opener = null; // extra safety/fallback
    }


  return (
    <>
      {showCE41Form === "formulario" && <CE20CompaniesOrg idBanco={idBanco}/>}
       
       {showCE41Form === "davivienda" && (
        <>
          { showBanco && dataConfig?.title_REGISTRE ? (
            <section className="ce20Wrap light">
              <div className="container">
                <div className="ce20">
                  <div className="ce20Title" style={{marginBottom: "2em"}}>
                    <h2>{dataConfig.title_REGISTRE}</h2>
                    {/* <p>{dataConfig.desc_REGISTRE}</p> */}
                  </div>
                  <Slider
                    {...settingsSlider}
                    className={``}
                    
                  >
                    {dataConfig.t_CARD_DAVIVIENDA_MOVIL ? (<div className="ce20Item">
                      <div className="cardSupport" onClick={() => {showMovilText();setShowCE41Form("formulario")}}>
                        {/* <i className="ico-edit-3"></i> */}
                        <h3 className="h4 ce20ItemHeader">
                          {Parser(dataConfig.t_CARD_DAVIVIENDA_MOVIL)}
                        </h3>
                        {/* {dataConfig?.d_CARD_DAVIVIENDA_MOVIL && <p className="ce20ItemDesc">{Parser(dataConfig.d_CARD_DAVIVIENDA_MOVIL)}</p>} */}
                      </div>
                    </div>):""}
                    {dataConfig.t_CARD_DAVIVIENDA_Hogar ? (<div onClick={() => setShowCE41Form("formularioHogar")} className="ce20Item">
                      <div className="cardSupport">
                        {/* <i className="ico-file-text"></i> */}
                        <h3 className="h4 ce20ItemHeader">
                          {Parser(dataConfig.t_CARD_DAVIVIENDA_Hogar)}
                        </h3>
                        {/* {dataConfig?.d_CARD_DAVIVIENDA_Hogar && <p className="ce20ItemDesc">{Parser(dataConfig.d_CARD_DAVIVIENDA_Hogar)}</p>} */}
                      </div>
                    </div>):""}
                    {dataConfig.t_CARD_DAVIVIENDA_EQUIPOS ? (<div className="ce20Item">
                      <div className="cardSupport" onClick={() => {openInNewTab("https://tienda.claro.com.co/claro/convenios-claro")}}>
                        {/* <i className="ico-user-check"></i> */}
                        <h3 className="h4 ce20ItemHeader">
                          {Parser(dataConfig.t_CARD_DAVIVIENDA_EQUIPOS)}
                        </h3>
                        {/* {dataConfig?.d_CARD_DAVIVIENDA_EQUIPOS && <p className="ce20ItemDesc">{Parser(dataConfig.d_CARD_DAVIVIENDA_EQUIPOS)}</p>} */}
                      </div>
                    </div>):""}
                  </Slider>
                  {/* <div className="ce20Extra">
                    {dataConfig?.text_EXTRA && <p>{Parser(String(  (dataConfig.text_EXTRA==null)?"":dataConfig.text_EXTRA ))}</p>}
                    <button
                      className="btn btnPrimario"
                      onClick={(e) => {
                        setShowCE41Form(!showCE41Form);
                      }}
                      disabled={
                        dataOfBanks?.length && dataPlanes.length ? false : true
                      }
                    >
                      Activar
                    </button>
                    
                  </div> */}
                  {/* <div className="ce20Copys">
                    <ul className="dottedList">
                      {Parser(String( (dataConfig.text_LIST==null)?"": dataConfig.text_LIST)  )}
                    </ul>
                    <p>{Parser(String( (dataConfig.text_DUDAS_CORREO==null)?"":dataConfig.text_DUDAS_CORREO ) )}</p>
                  </div> */}
                </div>
              </div>
            </section>
          ) : !showBanco ? 
            <section className="ce20Wrap light">
              <div className="container">
                <div className="ce20">
                  <div className="ce20Title">
                    <h2>Banco no disponible</h2>
                  </div>
                </div>
              </div>
            </section>            
          :null}
        </>
      )}

      { dataDocumentTypes.length && showCE41Form === "formularioHogar" && (
        <ActivarComponent
             idBanco={idBanco} 
             banks={dataOfBanks} 
             config={dataConfig}
             Terms5={txtTerms5}
             deparments={dataDepartments}
             entities={dataEntities}
             modalities={dataModalities}
            operators={dataOperators}
            documentType={dataDocumentTypes}
            planes={dataPlanes}
        />
      )}
    </>
  );
}

DaviviendaComponent.defaultProps = {
  refHead: [],
  itemsHeadRef: [],
};

export default DaviviendaComponent;
